import PubSub from "underpub-js";

var CalloutWithEmbedModal = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-CalloutWithEmbedModal',
	};

	$.extend(true, this.options, options);

};

CalloutWithEmbedModal.prototype.init = function() {

	var self = this;

};

export default CalloutWithEmbedModal;
